export const ABORTED_ERROR_STRING = 'Aborted'

export const abortError = (): Error => new Error(ABORTED_ERROR_STRING)

/** True for the rejection the pollers and callbacks settle with when their signal aborts. */
export const isAbortError = (error: unknown): boolean =>
  error instanceof Error ? error.message === ABORTED_ERROR_STRING : error === ABORTED_ERROR_STRING

/**
 * Runs `callback` when the signal aborts, right away if it already has. Returns the unsubscribe. A
 * missing signal never aborts.
 */
export const onAbort = (signal: AbortSignal | undefined, callback: () => void): (() => void) => {
  if (!signal) return () => {}
  if (signal.aborted) {
    callback()
    return () => {}
  }
  signal.addEventListener('abort', callback, { once: true })
  return () => signal.removeEventListener('abort', callback)
}
